<template>
<div>
<hero />
<div v-scrollanimation>
<theme-features />
</div>
<div v-scrollanimation>
<key-dates />
</div>
<div v-scrollanimation>
<sponsors />
</div>
<!--
<div v-scrollanimation>
<call-for-papers-orange />
</div>
<div v-scrollanimation>
<sponsors />
<partner-conferences />
</div>
-->
</div>
</template>
<script>
  // Extensions
  import View from '@/views/View'
  import Hero from '../sections/Hero.vue'
  import ThemeFeatures from '../sections/ThemeFeatures.vue'
  // import CallForPapersOrange from '../sections/CallForPapersOrange.vue'
  import KeyDates from '../sections/KeyDates.vue'
  // import Sponsors from '../sections/Sponsors.vue'
  // import PartnerConferences from '../sections/PartnerConferences.vue'
  // Mixins
  // import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Home',

    // components: { Hero, ThemeFeatures, CallForPapersOrange, KeyDates, Sponsors, PartnerConferences },
    components: { Hero, ThemeFeatures, KeyDates },
    metaInfo: { title: 'Home' },

    extends: View,

    /*
    mixins: [
      LoadSections([
        'hero',
        'theme-features',
        'call-for-papers-orange',
        'key-dates',
        'sponsors',
      ]),
    ],
    */

    props: {
      id: {
        type: String,
        default: 'home',
      },
    },
  }
</script>
